import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Heart, Mail, Lock, User } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import { useAuth } from '../context/AuthContext';
import { GoogleButton } from '../components/GoogleButton';

export default function Register() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { register } = useAuth();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.password) { toast({ title: 'Lengkapi semua field ya', variant: 'destructive' }); return; }
    if (form.password.length < 6) { toast({ title: 'Password minimal 6 karakter', variant: 'destructive' }); return; }
    setBusy(true);
    try {
      await register(form.name, form.email, form.password);
      toast({ title: 'Akun berhasil dibuat!', description: 'Mari lengkapi data pasanganmu.' });
      navigate('/onboarding');
    } catch (err) {
      toast({ title: 'Gagal daftar', description: err?.response?.data?.detail || 'Coba lagi', variant: 'destructive' });
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-cream-100 flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <div className="w-10 h-10 rounded-full bg-terracotta-500 flex items-center justify-center">
            <Heart className="w-5 h-5 text-white" fill="white" />
          </div>
          <div className="font-serif text-xl text-sage-700">Naik Pelaminan</div>
        </Link>

        <div className="bg-white rounded-3xl p-8 shadow-sm border border-cream-200">
          <h1 className="font-serif text-3xl text-sage-700 mb-2">Buat akun</h1>
          <p className="text-sage-500 text-sm mb-6">Mulai rangkai cerita pernikahanmu.</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label className="text-sage-600 text-sm">Nama panggilan</Label>
              <div className="relative mt-1.5">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-sage-400" />
                <Input data-testid="register-name-input" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} placeholder="Nama kamu" className="pl-10 h-11 bg-cream-50 border-cream-200 rounded-xl" />
              </div>
            </div>
            <div>
              <Label className="text-sage-600 text-sm">Email</Label>
              <div className="relative mt-1.5">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-sage-400" />
                <Input data-testid="register-email-input" type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} placeholder="kamu@email.com" className="pl-10 h-11 bg-cream-50 border-cream-200 rounded-xl" />
              </div>
            </div>
            <div>
              <Label className="text-sage-600 text-sm">Password</Label>
              <div className="relative mt-1.5">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-sage-400" />
                <Input data-testid="register-password-input" type="password" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} placeholder="Minimal 6 karakter" className="pl-10 h-11 bg-cream-50 border-cream-200 rounded-xl" />
              </div>
            </div>
            <Button data-testid="register-submit-button" type="submit" disabled={busy} className="w-full h-11 bg-terracotta-500 hover:bg-terracotta-600 text-white rounded-full">{busy ? 'Memproses...' : 'Daftar'}</Button>
          </form>

          <GoogleButton label="Daftar dengan Google" />

          <p className="mt-6 text-center text-sm text-sage-500">
            Sudah punya akun? <Link to="/login" className="text-terracotta-500 font-medium">Masuk</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
